import { User } from '../models'

export class AuthHelper {
    public static checkTokenExpired() {
        const user = this.getUser()
        if (!user) return true
        const expires = parseInt((user.expiresInSeconds)) * 1000
        const timeout = parseInt(this.getItem('timeout')) + expires
        const timeNow = Date.now()
        return timeout <= timeNow
    }

    public static initAuth(userData) {
        this.setItem('user', userData)
        this.setItem('token', this.getUser().token)
        this.setItem('timeout', Date.now())
    }

    public static getUser(): User {
        const user = this.getItem('user')
        if (user) return JSON.parse(user)
    }

    public static getToken(): string {
        return this.getItem('token')
    }

    public static getItem(name): string {
        if (localStorage.getItem(name)) {
            return `${ JSON.parse(localStorage.getItem(name)) }`
        } else {
            return ''
        }
    }

    public static setItem(name, value) {
        const encodeData = JSON.stringify(value)
        localStorage.setItem(name, JSON.stringify(encodeData))
    }

    public static destroyLocalStorageInfo() {
        localStorage.removeItem('user')
        localStorage.removeItem('token')
        localStorage.removeItem('timeout')
    }
}



// WEBPACK FOOTER //
// ./src/helper/auth.helper.ts